import React, { useContext } from 'react'

import { GuidedFilterShowcaseCarousel, useGuidedFilters } from '@Blocks/ProductList/GuidedFilters'
import { assignSlots, calculateMaxSlots, gridConfiguration } from '@Components/ProductList/Slots/Helpers'
import { ProductSearchContext, ProductSearchStaticContext } from '@Globals/Algolia/Context'
import { Content } from '@Globals/Injections/Client'

export const InjectionSlots = ({
  scrollToTop,
}: {
  scrollToTop?: () => void
}) => {
  const guidedFilters = useGuidedFilters()
  const { hitsArray, page } = useContext(ProductSearchContext)
  const { injections } = useContext(ProductSearchStaticContext)

  const indexStart = ((page || 1) - 1) * 4
  const indexEnd = indexStart + 4

  const slots = assignSlots(injections, guidedFilters)
  const maxSlots = calculateMaxSlots(hitsArray.length, slots.slice(indexStart, indexEnd).map(Boolean))

  return (
    <>
      {gridConfiguration.map((grid, index) => {
        if ((index + 1) > maxSlots) {
          return null
        }

        const slotIndex = (((page || 1) - 1) * 4) + index
        const slot = slotIndex + 1
        const item = slots[slotIndex]

        if (!item || !('__typename' in item)) {
          return null
        }

        if (item.__typename === 'GuidedFilterAttributeEnum' || item.__typename === 'GuidedFilterLinkResource') {
          return (
            <GuidedFilterShowcaseCarousel
              key={slot}
              guidedFilter={item}
              row={grid.row}
              scrollToTop={scrollToTop}
              style={{
                gridColumn: grid.column,
                gridRow: grid.row,
              }}
            />
          )
        }

        if (item.__typename === 'InjectionTypeBlockData') {
          return (
            <Content
              key={slot}
              blocks={item.blocks}
              idPrefix={`injection-slot-${slot}-`}
              style={{
                gridColumn: grid.column,
                gridRow: grid.row,
              }}
            />
          )
        }

        return null
      })}
    </>
  )
}
